module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "banner"
  }, _vm._l((_vm.cateList), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "banner_content",
      on: {
        "click": function($event) {
          return _vm.changeBanner(index)
        }
      }
    }, [_c('div', {
      class: index == _vm.tabIndex ?
        'banner_title banner_title_active' :
        'banner_title'
    }, [_vm._v("\n          " + _vm._s(item.name) + "\n        ")]), _vm._v(" "), (_vm.tabIndex == index) ? _c('div', {
      staticClass: "banner_icon"
    }) : _vm._e()])])
  }), 0), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative",
      "padding": "0.32rem 0.1rem"
    }
  }, [_c('div', {
    staticClass: "main-bottom-box"
  }, _vm._l((_vm.pageListRow), function(item, index) {
    return _c('div', {
      key: index
    }, [(item.type_id == 1) ? _c('saiItem', {
      attrs: {
        "row": item.info
      }
    }) : _vm._e(), _vm._v(" "), (item.type_id == 3) ? _c('goodsItem', {
      attrs: {
        "row": item.info
      }
    }) : _vm._e(), _vm._v(" "), (item.type_id == 4) ? _c('newsItem', {
      attrs: {
        "row": item.info
      }
    }) : _vm._e(), _vm._v(" "), (item.type_id == 2) ? _c('peiItem', {
      attrs: {
        "row": item.info
      }
    }) : _vm._e()], 1)
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62b3aaba","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/user/mine/collection/Collection.vue
// module id = 2421
// module chunks = 0